import { useState } from 'react';
import CustomMuiButton from '@/components/button/CustomMuiButton';
import SearchModal from '@/components/modal/search/SearchModal';

interface SetAppStoreButtonProps {
  showSearchModal: boolean;
  setShowSearchModal: (show: boolean) => void;
}

const SetAppStoreButton = ({ showSearchModal, setShowSearchModal }: SetAppStoreButtonProps) => {
  return (
    <>
      <CustomMuiButton size="l" label="병원 설정하기" type="PRIMARY" onClick={() => setShowSearchModal(true)} />
      {showSearchModal ? <SearchModal showModal={showSearchModal} handleShowModal={() => setShowSearchModal(!showSearchModal)} type="CHANGE" /> : ''}
    </>
  );
};

export default SetAppStoreButton;
